import { createContext } from 'react';

const MessageContext = createContext();

export default MessageContext;
